import styled, { css } from 'styled-components'
import { gray_6, white } from '../../theme/colors'
import { h4, h5, h6 } from '../../theme/type-styles'
import { xsLg } from '../../theme/utils/media-query'
import { spacing_0_5, spacing_0_75, spacing_1, spacing_3 } from '../../theme/spacing'

export function makeFooter (element) {
  return styled(element)`
    background: ${ gray_6 };
    color: ${ white };
    padding: ${ spacing_3 } ${ spacing_3 };
    ${h4};

    strong {
      font-weight: bold;
    }

    .footer-links {
      width: 540px;
    }

    .footer-section {
      width: 132px;
      text-align: left;
      a {
        display: block;
        color: ${ white };
        font-weight: normal;
        margin-top: ${ spacing_0_5 };
        &:hover, &:focus {
          text-decoration: underline;
        }
      }
    }

    .policies {
      margin: ${ spacing_1 } 0;
      a {
        color: ${ white };
        &:hover, &:focus {
          text-decoration: underline;
        }
      }
    }

    .social-icons {
      margin: ${ spacing_1 } 0;
      a {
        margin-right: ${ spacing_0_75 };
        transition: opacity 0.3s;
        opacity: 0.7;
        &:hover {
          transition: opacity 0.3s;
          opacity: 1;
        }
      }
    }

    .special-links {
      text-align: left;
      ${h5};
    }

    .policies, .copyright {
      ${h6};
    }

    ${xsLg(css`
      .footer-section {
        margin-bottom: ${ spacing_3 };
        text-align: center;
      }

      .special-links, .footer-links {
        width: 100%;
        text-align: center;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .special-links {
        margin-bottom: ${ spacing_3 };
      }
    `)}
  `
}

export default makeFooter